const STORAGE_KEY = "engine-config-ui";

const DEFAULT_FILTERS = {
  type: "",
  version: "",
  url: "",
  database: "",
  search: ""
};

const normalizePath = (pathname) => {
  const base = process.env.PUBLIC_URL || "";
  let path = pathname || "/";
  if (base && path.startsWith(base)) {
    path = path.slice(base.length) || "/";
  }
  return path;
};

export const isEngineConfigRoute = (pathname) => {
  const path = normalizePath(pathname);
  return path === "/engine-config" || path.startsWith("/engine-config/");
};

export const loadEngineConfigPersistence = () => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const saveEngineConfigPersistence = (data) => {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch (error) {
    console.warn("Failed to persist engine config state", error);
  }
};

export const clearEngineConfigPersistence = () => {
  sessionStorage.removeItem(STORAGE_KEY);
};

export const getPersistedEngineConfigUiState = () => {
  const data = loadEngineConfigPersistence();
  if (!data) {
    return {
      filters: { ...DEFAULT_FILTERS },
      createModalOpen: false,
      formValues: null
    };
  }

  return {
    filters: { ...DEFAULT_FILTERS, ...(data.filters || {}) },
    createModalOpen: Boolean(data.createModalOpen),
    formValues: data.formValues && typeof data.formValues === "object" ? data.formValues : null
  };
};
